import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ToastService } from '../../shared/services/toast/toast.service';
import { VisaStatusService } from '../../shared/services/visa-status.service';

@Component({
  selector: 'app-interrogate',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './interrogate.component.html',
  styleUrls: ['./interrogate.component.scss'],
})
export class InterrogateComponent {
  param = '';
  isResult: boolean | null = null;
  sended: boolean = false;
  data: any = null;
  contactPerson: any = null;
  visaStatuslist: any = null;
  status: string = '';
  _http = inject(HttpClient);
  _toast = inject(ToastService);
  _visaStatusService = inject(VisaStatusService);
  constructor() {
    this.getVisaStatus();
  }
  maxLength = 14;
  check(e: any) {
    this.param = e.target.value;
    // boşluk temizleme
    this.param = this.param.replace(/\s/g, '');
    // kontrol yapacağız burada
    // eğer U ile başlıyorsa demek pasaport ve 9 haneli
    // eğer rakamsa 11 haneli TC
    // eğer rakamsa 14 haneli başvuru numarası
    if (this.param.startsWith('U') && this.param.length === 10) {
      this.maxLength = 10; // Pasaport numarası
    } else if (/^\d+$/.test(this.param) && this.param.length === 11) {
      this.maxLength = 11; // TC Kimlik numarası
    } else if (/^\d+$/.test(this.param) && this.param.length === 14) {
      this.maxLength = 14; // Başvuru numarası
    } else {
      this.maxLength = 14; // Varsayılan olarak başvuru numarası
    }
  }
  hasValue(obj: any): boolean {
    return obj !== null && obj !== undefined && Object.keys(obj).length > 0;
  }
  getVisaStatus() {
    this._visaStatusService.getAll().subscribe((data) => {
      this.visaStatuslist = data;
    });
  }
  getVisaDetails() {
    if (this.hasValue(this.param) === false) {
      this._toast.Error('Lütfen başvuru numarasını giriniz');
      return;
    }
    const url = environment.apiUrl + '/VisaApplication/Interrogate?param=' + this.param;
    this._http
      .get(url, {
        observe: 'response',
        headers: {
          skipLoad: 'true',
        },
      })
      .subscribe(
        (responsse) => {
          if (responsse.status === 200 && responsse.body) {
            this.data = responsse.body;
            const customers = this.data.customers;
            this.contactPerson = customers.find((x: any) => x.passport_No === this.data.contactCustomerPassport_No);
            this.isResult = true;
            this.sended = true;
            this.status = this.visaStatuslist.find((x: any) => x.id === this.data.visaStatusId)?.description;
          } else {
            this.isResult = false;
            this.data = null;
            this.sended = true;
            this.contactPerson = null;
            this._toast.Error(responsse.body?.toString() || 'Error');
          }
        },
        (error) => {
          this.isResult = false;
          this.data = null;
          this.sended = true;
          this.contactPerson = null;
          this._toast.Error('başvuru bulunmadı');
        }
      );
  }
}
